import axios from "axios";

const OPTIONS_URL = "/translations/getDropDownItems";

export const getDropdownOptions = ({ddType}) => {
  return axios.get(OPTIONS_URL, {params: {ddType}})
    .then(response => response.data.data.items)
};
